import { createLocaleMessages } from "./createLocaleMessages";

export const ES_TRANSLATIONS = createLocaleMessages({
  common: {
    appName: "Screen0",
    loading: "Cargando…",
    loadingSettings: "Cargando ajustes",
    loadingInsight: "Cargando insight…",
    close: "Cerrar",
    cancel: "Cancelar",
    save: "Guardar",
    delete: "Eliminar",
    done: "Listo",
    send: "Enviar",
    add: "Añadir",
    create: "Crear",
    edit: "Editar",
    available: "Disponible",
    unavailable: "No disponible",
    checking: "comprobando",
    somethingWentWrong: "Algo salió mal",
    today: "Hoy",
    thisWeek: "Esta semana",
    thisMonth: "Este mes",
    backToToday: "Volver a Hoy",
    openSettings: "Abrir ajustes",
    primaryNavLabel: "Principal",
    noUsage: "Sin uso",
    emDash: "—",
    thinking: "Pensando...",
    opening: "Abriendo…",
    ok: "OK",
    dismiss: "Descartar",
    unknown: "Desconocido",
  },
  navigation: {
    today: "Hoy",
    habits: "Hábitos",
    insight: "Insight",
    rules: "Reglas",
    settings: "Ajustes",
    premiumLocked: "Premium",
  },
  today: {
    titleToday: "Hoy",
    titleThisWeek: "Esta semana",
    titleThisMonth: "Este mes",
    periodDay: "Día",
    periodWeek: "Semana",
    periodMonth: "Mes",
    periodLabel: "Periodo",
    viewApps: "Apps",
    viewCategories: "Categorías",
    metricScreenTime: "Tiempo en pantalla",
    metricScreenTimeAndroid: "Tiempo de uso",
    metricActivations: "Activaciones",
    viewToggleAria: "Vista: {view}. Toca para cambiar.",
    metricToggleAria: "Métrica: {metric}. Toca para cambiar.",
    periodToggleAria: "Periodo: {period}. Toca para cambiar.",
    prevNavAria: "{period} anterior",
    nextNavAria: "{period} siguiente",
    navDay: "día",
    navWeek: "semana",
    navMonth: "mes",
    noSnapshotDayTitle: "Sin instantánea para este día",
    noSnapshotWeekTitle: "Sin instantáneas para esta semana",
    noSnapshotMonthTitle: "Sin instantáneas para este mes",
    noSnapshotDayBody:
      "No se guardó ninguna instantánea para este día. Prueba otra fecha o vuelve a hoy.",
    noSnapshotWeekBody:
      "Esta semana aún no tiene suficientes instantáneas guardadas. Prueba una semana anterior o vuelve después de más capturas diarias.",
    noSnapshotMonthBody:
      "Este mes aún no tiene suficientes instantáneas guardadas. Prueba un mes anterior o vuelve después de más capturas diarias.",
    preInstallDayTitle: "Sin datos para este día",
    preInstallDayBody:
      "Los datos de uso solo están disponibles desde que instalaste Screen0 en este dispositivo. Las fechas anteriores no están disponibles.",
    preInstallWeekTitle: "Sin datos para esta semana",
    preInstallWeekBody:
      "Toda esta semana es anterior a la instalación de Screen0 en este dispositivo, por lo que no hay datos de uso.",
    preInstallMonthTitle: "Sin datos para este mes",
    preInstallMonthBody:
      "Todo este mes es anterior a la instalación de Screen0 en este dispositivo, por lo que no hay datos de uso.",
    noUsageRecorded: "Aún no hay uso registrado",
    permissionNeededTitle: "Se necesita permiso para el informe de hoy",
    permissionNeededBody:
      "Screen0 funciona sin cuenta, pero iOS requiere permiso de Tiempo en pantalla antes de mostrar el uso de apps.",
    permissionDeniedHint:
      "Abre Ajustes y toca Solicitar acceso a Tiempo en pantalla, luego aprueba el diálogo de Apple «Uso de apps y sitios web» para desbloquear el informe de hoy.",
    reasonIosDataExportRequires264:
      "Apple solo permite leer datos de Tiempo en pantalla en iOS 26.4 o posterior. Actualiza iOS para ver el uso aquí.",
    reasonDataExportUnavailable:
      "Apple actualmente solo permite exportar datos de Tiempo en pantalla en dispositivos de la UE, por lo que no se puede leer ningún uso en este dispositivo.",
    reasonExtensionSnapshotMissing:
      "La extensión del informe se inició, pero la instantánea del grupo de apps no era legible en esta ejecución.",
    reasonReportViewNotMounted:
      "Screen0 no pudo montar el host nativo del informe de Actividad del dispositivo.",
    reasonDefaultNoData:
      "Usa el teléfono unos minutos, luego vuelve a Hoy o reabre Screen0. iOS también puede no devolver datos al inicio del día.",
    permissionNeededBodyAndroidRestricted:
      "Android bloqueó este permiso porque Screen0 se instaló fuera de una tienda de apps. Primero toca «Abrir información de la app Screen0» abajo, abre el menú ⋮ arriba a la derecha y elige «Permitir ajustes restringidos» (confirma con tu PIN). Luego vuelve y activa el acceso a datos de uso.",
    openAppInfo: "Abrir información de la app Screen0",
    reasonDefaultNoDataAndroid:
      "El acceso a datos de uso está activo. Usa el dispositivo unos minutos y vuelve a Hoy o reabre Screen0 — Android puede tardar un poco en devolver los primeros datos.",
    collectingUsageTitle: "Leyendo datos de uso…",
    collectingUsageBody:
      "El acceso a datos de uso está activo. Screen0 está leyendo el uso de hoy — solo tarda un momento.",
    collectingUsageBodyAndroid:
      "El acceso a datos de uso está activo. Screen0 está leyendo el uso de hoy desde Android — justo después de conceder el acceso puede tardar unos segundos.",
    reasonUsageEventsUnavailableAndroid:
      "El acceso a datos de uso parece activo, pero Android aún no comparte datos con Screen0. Abre Ajustes, desactiva y vuelve a activar el acceso para Screen0 y reabre la app. En instalaciones fuera de una tienda, primero elige «Permitir ajustes restringidos» desde Información de la app (menú ⋮).",
    reasonAppsNotVisibleAndroid:
      "Android registró uso, pero Screen0 no pudo identificar las apps. Actualiza o reinstala Screen0 e inténtalo de nuevo.",
    weeklyActivationsNotTracked: "Las activaciones semanales aún no se registran",
    monthlyActivationsNotTracked: "Las activaciones mensuales aún no se registran",
    activationsNotTracked: "Activaciones aún no registradas",
    topApps: "Apps principales",
    allApps: "Todas las apps",
    topCategories: "Categorías principales",
    allCategories: "Todas las categorías",
    topActivations: "Activaciones principales",
    allActivations: "Todas las activaciones",
    topCategoryActivations: "Activaciones por categoría principales",
    allCategoryActivations: "Todas las activaciones por categoría",
    viewAllAppsAria: "Ver todas las apps",
    viewAllCategoriesAria: "Ver todas las categorías",
    viewAllActivationsAria: "Ver todas las activaciones",
    viewAllCategoryActivationsAria: "Ver todas las activaciones por categoría",
    dayShape: "Forma del día",
    weekShape: "Forma de la semana",
    monthShape: "Forma del mes",
    dailyAverage: "Prom. día",
    dailyAverageOn: "activado",
    dailyAverageOff: "desactivado",
    dailyAverageToggleAria: "Promedio diario {state}. Toca para alternar.",
  },
  habits: {
    title: "Hábitos",
    timeframe: "Últimos 12 meses",
    reorder: "Reordenar apps",
    doneReordering: "Reordenación completada",
    openFilter: "Abrir filtro de hábitos",
    metricToggleAria: "Métrica: {metric}. Toca para cambiar.",
    emptyTitle: "Aún no hay datos de uso de apps",
    emptyBody:
      "Permite el acceso a Tiempo en pantalla desde Hoy para registrar hábitos.",
    emptyBodyAndroid:
      "Permite el acceso a datos de uso desde Hoy para registrar hábitos.",
    filterView: "Vista",
    filterTrackApps: "Registrar apps",
    filterTrackCategories: "Registrar categorías",
    filterCategories: "Categorías",
    filterShowingAll: "Mostrando todo. Selecciona para registrar solo elementos específicos.",
    filterTrackingSelected: "Registrando {count} seleccionados.",
    filterSearchPlaceholder: "Buscar apps que has usado",
    filterSearchAria: "Buscar apps",
    closeFilter: "Cerrar filtro",
    previousMonth: "Mes anterior",
    nextMonth: "Mes siguiente",
    filterOtherSection: "Bucket Otro",
    includeOther: "Incluir Otro",
    includeOtherAria: "Incluir el bucket Otro en hábitos",
    includeOtherInfoAria: "¿Qué es el bucket Otro?",
    otherInfoTitle: "¿Qué es Otro?",
    otherInfoBody:
      "Otro es el tiempo de pantalla que iOS no pudo asignar a una app concreta. Suele proceder de apps desinstaladas, uso del sistema o pequeñas diferencias entre tu Tiempo en pantalla total y la suma de las apps individuales.",
    otherInfoBodyAndroid:
      "Otro es el tiempo de uso que Android no pudo asignar a una app concreta. Suele proceder de apps desinstaladas, uso del sistema o pequeñas diferencias entre tu uso total y la suma de las apps individuales.",
  },
  insight: {
    title: "Insight",
    timeframe: "Últimos {days} días",
    compulsivity: "Compulsividad",
    doomScrollRisk: "Doom-scroll",
    aboutMetricAria: "Acerca de {metric}",
    compulsivityBody1:
      "Con qué frecuencia vuelves a abrir las mismas apps en relación con todo lo demás en tu teléfono. Puntuaciones altas suelen indicar desbloqueos frecuentes y visitas repetidas, no solo sesiones largas.",
    compulsivityBody2:
      "Screen0 combina la frecuencia con la que se abre una app, cuánto tiempo total ocupa y en cuántos días aparece en tus instantáneas recientes.",
    compulsivityBody3:
      "Son estimaciones proxy de los últimos 14 días — patrones útiles, no una medida clínica.",
    doomBody1:
      "Apps cuyo uso tiende a repetirse y concentrarse en unas pocas horas del día — el tipo de patrón que puede derivar en scroll automático, en cualquier momento.",
    doomBody2:
      "Screen0 pondera cuánto tiempo ocupa una app, con qué consistencia aparece y cuán concentrado está ese uso a lo largo del día en tus instantáneas recientes.",
    doomBody3:
      "Las puntuaciones son estimaciones proxy de los últimos 14 días y reflejan hábitos, no intenciones.",
    activateSmartBlockAria: "Activar Smart Block para {appName}",
    reactivateSmartBlockAria: "Reactivar Smart Block para {appName}",
    activeSmartBlocksTitle: "Smart Blocks activos",
    activeSmartBlocksAria: "Reglas de Smart Block activas en este dispositivo",
    goToActiveSmartBlockRuleAria: "Ir a la regla de {appName}",
    activateSmartBlockTitle: "¿Activar este Smart Block?",
    reactivateSmartBlockTitle: "¿Reactivar este Smart Block?",
    activateConfirmBody:
      "Crea una regla activa que suspende {appName} cada día, {window}.",
    reactivateConfirmBody:
      "Reactiva tu regla existente para {appName} cada día, {window}.",
    activate: "Activar",
    reactivate: "Reactivar",
    notFoundTitle: "Insight no encontrado",
    notFoundBody: "Este insight puede haber sido eliminado o aún no se ha generado.",
    statusPermissionNeededBodyAndroid:
      "Permite el acceso a datos de uso desde Hoy antes de que Insight pueda valorar los patrones de apps recientes.",
    openExclude: "Gestionar apps excluidas de Insight",
    excludeSheetTitle: "Excluir de Insight",
    closeExclude: "Cerrar exclusiones",
    excludeSectionLabel: "Apps excluidas",
    excludeHelperAllIncluded:
      "Todas las apps se incluyen en las puntuaciones de Insight. Marca apps para excluirlas de compulsividad, doom-scroll y sugerencias Smart Block.",
    excludeHelperCount: "{count} apps excluidas de las puntuaciones de Insight.",
    excludeSearchPlaceholder: "Buscar apps que has usado",
    excludeSearchAria: "Buscar apps",
    excludeSearchResults: "Resultados de búsqueda",
    excludeSearching: "Buscando…",
    excludeNoMatchingApps: "No hay apps coincidentes",
    excludeNoApps: "Aún no hay apps en este periodo",
    excludeIncludeAll: "Incluir todas",
    smartBlockPrePickerTitle: "Elige apps en Tiempo en pantalla",
    smartBlockPrePickerReactivateTitle: "Vuelve a elegir apps en Tiempo en pantalla",
    smartBlockPrePickerBody:
      "La siguiente pantalla es el selector de apps de Apple. Elige {appName} para que Screen0 pueda bloquearla en esta ventana de Smart Block.",
    smartBlockPrePickerReactivateBody:
      "La siguiente pantalla es el selector de apps de Apple. Elige {appName} de nuevo para que Screen0 aplique este Smart Block.",
    smartBlockPrePickerNext: "Siguiente",
    smartBlockPickerTitle: "Elige {appName}",
    smartBlockPickerHeader: "Elige {appName}",
    smartBlockPickerFooter:
      "Selecciona la app sugerida por tu Smart Block. Screen0 no puede verificar tu elección — elige con cuidado.",
    smartBlockHonorTitle: "¿Elegiste {appName}?",
    smartBlockHonorBody:
      "En la pantalla anterior debiste seleccionar la app a la que apunta este Smart Block.",
    smartBlockHonorYes: "Sí, continuar",
    smartBlockHonorNo: "No",
    smartBlockDeclinedTitle: "El Smart Block necesita {appName}",
    smartBlockDeclinedBody:
      "Este Smart Block no se puede crear a menos que elijas {appName} en el selector de Apple.",
    smartBlockRetryPicker: "Intentar de nuevo",
    smartBlockNonConformingTitle: "La selección no coincide con el Smart Block",
    smartBlockNonConformingBody:
      "Seleccionaste {appCount} apps, {categoryCount} categorías y {siteCount} sitios web. La regla puede crearse igual, pero no se etiquetará como Smart Block.",
    smartBlockNonConformingContinue: "Crear regla manual",
  },
  rules: {
    title: "Reglas",
    reorder: "Reordenar",
    doneReordering: "Reordenación completada",
    dismiss: "Descartar",
    activeRulesTitle: "Reglas programadas",
    activeRulesLoading: "Cargando…",
    activeRulesEnforcing: "{count} aplicándose ahora",
    activeRulesEmptySchedule: "Programar una suspensión",
    noActiveRulesTitle: "Sin reglas programadas",
    noActiveRulesBody:
      "Elige qué bloquear, cuándo y qué días — tu primera regla lleva unos minutos.",
    newRule: "Nueva regla",
    targetsTitle: "Objetivos",
    targetsSaved: "{count} guardados",
    targetsEmptySubtitle: "Grupos de bloqueo reutilizables para apps y sitios",
    noTargetsTitle: "Sin objetivos",
    noTargetsBody:
      "Crea un grupo con nombre de apps, sitios o categorías — luego reutilízalo en reglas y sesiones rápidas.",
    newTarget: "Nuevo objetivo",
    addSectionAria: "Añadir {title}",
    deleteRuleAria: "Eliminar regla",
    deleteTargetAria: "Eliminar objetivo",
    deleteRuleConfirmAria: "¿Eliminar esta regla?",
    deleteTargetConfirmAria: "¿Eliminar este objetivo?",
    deleteRuleConfirm: "¿Eliminar esta regla?",
    deleteTargetConfirm: "¿Eliminar este objetivo?",
    deleteRuleCoveredConfirm:
      "¿Eliminar esta regla? Las mismas apps y sitios siguen bloqueados por otra regla activa.",
    deleteTargetCoveredConfirm:
      "¿Eliminar este objetivo? Las mismas apps y sitios siguen bloqueados por otra regla activa.",
    deleteRuleCoveredConfirmAria: "¿Eliminar esta regla manteniendo el bloqueo?",
    deleteTargetCoveredConfirmAria: "¿Eliminar este objetivo manteniendo el bloqueo?",
    editRuleAria: "Editar {name}",
    editTargetAria: "Editar {targetName}",
    enableRuleAria: "Activar regla",
    disableRuleAria: "Desactivar regla",
    noTargets: "Sin objetivos",
    ruleUpdated: "Regla actualizada.",
    ruleCreated: "Regla creada.",
    ruleSaveFailed: "No se pudo guardar la regla. Inténtalo de nuevo.",
    targetCreated: "Objetivo creado.",
    targetUpdated: "Objetivo actualizado.",
    targetSaveFailed: "No se pudo guardar el objetivo. Inténtalo de nuevo.",
    ruleDeleted: "Regla eliminada.",
    targetDeleted:
      "Objetivo eliminado. Se eliminaron las reglas que usaban solo este objetivo.",
    editRule: "Editar regla",
    newRuleEditor: "Nueva regla",
    saveRule: "Guardar regla",
    createRule: "Crear regla",
    editTarget: "Editar objetivo",
    newTargetEditor: "Nuevo objetivo",
    saveTarget: "Guardar objetivo",
    createTarget: "Crear objetivo",
    targetsSection: "Objetivos",
    targetsLimitHint: "Hasta {max} por regla",
    targetsLimitReached: "Puedes seleccionar hasta {max} objetivos por regla. Deselecciona uno para añadir otro.",
    targetsRequired: "Selecciona al menos un objetivo para guardar esta regla.",
    targetEditorFromRule: "Añadir un objetivo para esta regla",
    targetEditorFromQuickStart: "Añadir un objetivo para inicio rápido",
    backToRule: "Volver a la regla",
    backToQuickStart: "Volver al inicio rápido",
    websiteCategoriesLink: "Explorar categorías de sitios",
    websiteCategoriesHint: "Bloquea grupos enteros como Redes sociales o Noticias — sin escribir dominios.",
    createTargetCta: "Crea tu primer objetivo",
    createTargetHint: "Pon nombre a un grupo de apps o sitios, luego elígelo en las reglas.",
    daysSection: "Días",
    timeWindowSection: "Ventana horaria",
    startLabel: "Inicio",
    endLabel: "Fin",
    endsLabel: "Termina",
    durationMode: "Duración",
    endTimeMode: "Hora de fin",
    blockDurationAria: "Duración del bloqueo en minutos",
    targetNamePlaceholder: "p. ej. Redes sociales, Distracciones del trabajo",
    chooseAppsSites: "Elegir apps y sitios para bloquear",
    websitePlaceholder: "ejemplo.com",
    websiteAria: "Dominio del sitio web",
    tapToChangeBlocked: "Toca para cambiar qué se bloquea",
    chosenOnDevice: "Elegido en este iPhone",
    changeBlockedAppsAria: "Cambiar apps bloqueadas",
    viewFullBlockedListAria: "Ver lista completa de bloqueados",
    view: "Ver",
    smartBlockBadge: "Smart Block",
    smartBlockRuleWindowTitle: "Editar horario del Smart Block",
    smartBlockRuleWindowBody:
      "Solo puedes cambiar cuándo se activa este Smart Block. Las apps, los días y el resto de ajustes permanecen bloqueados.",
    smartBlockRuleWindowAria: "Editar franja horaria del Smart Block",
    smartBlockMinDurationError: "Los Smart Blocks deben durar al menos 1 hora.",
    smartBlockEndBeforeStartError: "La hora de fin debe ser posterior a la de inicio.",
    smartBlockRuleNotEditable: "No puedes editar una regla de Smart Block.",
    smartBlockTargetNotEditable: "Los objetivos de Smart Block no se pueden editar.",
    smartBlockRuleNotEditableAria: "Regla de Smart Block no editable",
    smartBlockTargetNotEditableAria: "Objetivo de Smart Block no editable",
    enforcementBannerTitle: "En aplicación ahora",
    enforcementBannerEndsIn: "Termina en {time}",
    enforcementBannerMore: "+{count} más",
    enforcementBreakBannerTitle: "Pausa activa",
    enforcementBreakBannerEndsIn: "Termina en {time}",
    quickStart: {
      fabLabel: "Iniciar",
      fabAria: "Iniciar una sesión de bloqueo rápida",
      drawerTitle: "Inicio rápido",
      durationLabel: "Duración",
      durationAria: "Duración de la sesión rápida en minutos",
      recentTab: "Recientes",
      savedTab: "Guardadas",
      savePrompt: "Ponle nombre a esta sesión",
      savePromptTitle: "Guardar en favoritos",
      savePromptHint: "Toca la estrella en una sesión reciente para reutilizarla con un toque.",
      saveNamePlaceholder: "p. ej. Hora de enfoque",
      noRecents: "No hay sesiones recientes",
      noSaved: "No hay sesiones guardadas",
      createTarget: "Nuevo objetivo",
      changeIcon: "Cambiar icono",
      sessionActive: "Bloqueo activo",
      saveStarAria: "Guardar sesión",
      savedStarAria: "Sesión guardada",
      defaultSessionName: "Sesión",
      startButton: "Iniciar sesión de bloqueo",
      noValidTargets: "Esos objetivos se eliminaron. Selecciona al menos un objetivo.",
    },
    swipeUnlock: {
      trackLabel: "Desliza para detener el bloqueo",
      trackAria: "Arrastra para detener todos los bloqueos",
      overlayTitle: "Mantén pulsado para desbloquear",
      overlayBody: "Esto detiene ahora mismo cada regla y sesión activa. Mantén pulsado para confirmar que realmente quieres desbloquear.",
      holdAria: "Mantén pulsado para confirmar",
      holdHint: "Sigue manteniendo pulsado…",
      takeBreak: "Tomar un descanso de {minutes} minutos",
    },
    forcedSuspend: {
      badge: "En pausa",
      subtitle: "Toca power para reanudar el bloqueo.",
      autoResume: "Se reanuda {time}.",
      resumeRuleAria: "Reanudar el bloqueo de esta regla",
    },
    vpnInstallPrompt: {
      title: "Instala el filtro de sitios",
      body: "Una regla está bloqueando sitios ahora mismo. Instala el perfil VPN en el dispositivo para que sigan bloqueados en Safari.",
      bodyAndroid:
        "Una regla está bloqueando sitios ahora mismo. Instala el perfil VPN en el dispositivo para que sigan bloqueados en Chrome y otros navegadores.",
      install: "INSTALAR PERFIL",
      installing: "INSTALANDO…",
      notNow: "AHORA NO",
      dismissAria: "Cerrar aviso del filtro de sitios",
    },
    vpnWebTargetGate: {
      title: "Filtro de sitios requerido",
      body:
        "Bloquear sitios requiere el perfil de filtro en el dispositivo. Los objetivos solo de apps funcionan sin él — instala el perfil para añadir dominios o categorías.",
      banner:
        "Instala el filtro de sitios en el dispositivo para añadir dominios o categorías aquí.",
      install: "INSTALAR PERFIL",
      installing: "INSTALANDO…",
      continueAppsOnly: "Solo apps",
      dismissAria: "Cerrar requisito del filtro de sitios",
      saveBlocked: "Instala el filtro de sitios para guardar nuevos dominios o categorías.",
    },
  },
  chat: {
    title: "Pregunta a Screen0",
    engineIosLocal: "IA local en iOS",
    engineAndroidLocal: "IA local en Android",
    engineCloud: "IA en la nube",
    closeChatAria: "Cerrar chat",
    suggestionWhatChanged: "¿Qué cambió hoy?",
    suggestionWhichApp: "¿Qué app me enganchó?",
    suggestionTonight: "¿Qué probar esta noche?",
    placeholder: "Pregunta sobre tu uso",
    sendAria: "Enviar",
    unableToAnswer: "No puedo responder ahora mismo.",
    localAiUnavailableSuffix:
      "La IA local no está disponible ahora. El chat en la nube no se usa automáticamente en este dispositivo.",
  },
  insightChat: {
    fabAria: "Preguntar sobre el uso del teléfono",
    title: "Chat de uso",
    privacyBadge: "100 % en el dispositivo",
    engineIosLocal: "IA local en iOS",
    engineAndroidLocal: "IA local en Android",
    greeting:
      "¿Qué te gustaría saber sobre cómo usas el teléfono? Puedo explicar patrones de tu ventana Insight reciente.",
    suggestionTotalUsage: "¿Cuánto he usado el teléfono?",
    suggestionTopApp: "¿Qué app uso más?",
    suggestionBusiestDays: "¿Qué días uso más el teléfono?",
    suggestionBusiestBands: "¿Qué franjas horarias son las más activas?",
    suggestionTopAppWhy: "¿Por qué suelo usar {appName} tanto?",
    suggestionTopAppWhyGeneric: "¿Por qué suelo usar tanto mi app más usada?",
    suggestionComparePeriods: "Comparar este periodo con el anterior",
    placeholder: "Pregunta sobre tus patrones de uso",
    sendAria: "Enviar mensaje",
    closeAria: "Cerrar chat de uso",
    unableToAnswer: "No puedo responder ahora mismo.",
    contextLoading: "Preparando el contexto de uso…",
    contextError: "No se pudo cargar el contexto de uso. Inténtalo de nuevo o cierra y vuelve a abrir el chat.",
    contextEmpty: "Aún no hay suficientes datos de uso recientes para el chat.",
    retryContext: "Reintentar",
  },
  settings: {
    title: "Ajustes",
    controlsEyebrow: "Controles",
    screenTimeSection: "Tiempo en pantalla",
    screenTimeSectionAndroid: "Acceso a datos de uso",
    permissionLabel: "Permiso",
    requestingAccess: "Solicitando acceso",
    requestScreenTimeAccess: "Solicitar acceso a Tiempo en pantalla",
    legalSection: "Legal",
    privacyPolicyRow: "Política de privacidad",
    termsRow: "Términos",
    resetSection: "Restablecer",
    deletingSavedData: "Eliminando datos guardados",
    deleteSavedData: "Eliminar datos guardados y restablecer ID del dispositivo",
    resetSuccess:
      "Se eliminaron {count} registros guardados. Se creó un nuevo ID de dispositivo anónimo.",
    resetFailed: "Error al restablecer.",
    footerNoAccount: "No se requiere cuenta.",
    languageRow: "Idioma",
    purchasesSection: "Compras",
  },
  language: {
    eyebrow: "Idioma app",
    title: "Idiomas",
    subtitle:
      "Screen0 sigue el idioma preferido de la app configurado en el sistema. Cámbialo desde Ajustes del iPhone cuando quieras.",
    subtitleAndroid:
      "Screen0 sigue el idioma preferido de la app configurado en el sistema. Cámbialo desde Ajustes de Android cuando quieras.",
    subtitleAndroidLegacy:
      "En esta versión de Android, Screen0 sigue el idioma del dispositivo. Cámbialo en Ajustes → Idiomas e introducción de texto.",
    activeLanguageLabel: "Idioma activo",
    systemLanguageLabel: "Preferencia del sistema",
    fallbackNote:
      "El idioma del sistema seleccionado aún no es compatible con Screen0, por lo que la app usa inglés como alternativa.",
    unavailableSystemValue: "No disponible",
    openSettingsTitle: "Abrir Ajustes del iPhone",
    openSettingsTitleAndroid: "Abrir ajustes de idioma de la app",
    openSettingsTitleAndroidLegacy: "Abrir Ajustes de Android",
    openSettingsSubtitle:
      "Ve a la página del sistema de Screen0 para cambiar el idioma de la app.",
    openSettingsSubtitleAndroid:
      "Ve a la página de idioma de Screen0 para cambiar el idioma de la app.",
    openSettingsSubtitleAndroidLegacy:
      "Se abre la ficha de la app. Cambia el idioma del dispositivo en Idiomas: el idioma por app requiere Android 13 o posterior.",
    openingSettingsLabel: "Abriendo Ajustes",
    closeLabel: "Cerrar",
    footerReady:
      "Cuando vuelvas a la app, Screen0 sincroniza automáticamente el idioma actualizado.",
    footerReadyAndroid:
      "Cuando vuelvas a la app, Screen0 sincroniza automáticamente el idioma actualizado.",
    footerReadyAndroidLegacy:
      "Cuando vuelvas a la app, Screen0 se sincroniza con el idioma del dispositivo.",
    footerOpening: "Abriendo la página del sistema...",
    openSettingsUnavailableTitle: "Ajustes no disponibles",
    openSettingsUnavailableDescription:
      "No puedo abrir los Ajustes de la app desde este entorno.",
  },
  permission: {
    gateTitle: "Se necesita permiso para el informe de hoy",
    gateBody:
      "Screen0 funciona sin cuenta, pero iOS requiere permiso de Tiempo en pantalla antes de mostrar el uso de apps.",
    requestingAccess: "Solicitando acceso",
    requestScreenTimeAccess: "Solicitar acceso a Tiempo en pantalla",
    entitlementMissing:
      "Esta compilación no incluye el entitlement Family Controls o el perfil de aprovisionamiento correspondiente. No se pueden recopilar datos de Tiempo en pantalla hasta corregir la firma.",
  },
  calendar: {
    chooseDate: "Elegir fecha",
    previousMonth: "Mes anterior",
    nextMonth: "Mes siguiente",
  },
  query: {
    loadingDefault: "Cargando…",
    errorTitle: "Algo salió mal",
  },
  app: {
    syncError:
      "No se pudo guardar el uso de hoy. Screen0 reintentará cuando vuelvas a abrir la app.",
    reinstallRulesPurged:
      "Tus reglas de bloqueo se restablecieron porque las selecciones de apps no se conservan tras reinstalar. Configúralas de nuevo en Reglas.",
  },
  format: {
    activationSingular: "Activación",
    activationPlural: "Activaciones",
    durationMinutes: "{minutes} min",
    durationHoursOnly: "{hours} h",
    durationOneHour: "1 h",
    durationHoursMinutes: "{hours} h {minutes} min",
    allDay: "Todo el día",
    timeBandMorning: "mañana",
    timeBandAfternoon: "tarde",
    timeBandEvening: "noche",
    timeBandNight: "madrugada",
  },
  appDetail: {
    dailyAverage: "Promedio diario",
    dailyAverageInfoAria: "Acerca del promedio diario de {metric}",
    dailyAverageInfoBodyTime1:
      "Tiempo de pantalla horario promedio de esta app en los últimos ~12 meses.",
    dailyAverageInfoBodyTime2:
      "Cada hora es el promedio de todos los días con datos del dispositivo en ese periodo. Los días sin uso de esta app cuentan como cero. Se excluyen los días anteriores al inicio de la recopilación de datos.",
    dailyAverageInfoBodyOpens1:
      "Activaciones horarias promedio de esta app en los últimos ~12 meses.",
    dailyAverageInfoBodyOpens2:
      "Cada hora es el promedio de todos los días con datos del dispositivo en ese periodo. Los días sin uso de esta app cuentan como cero. Se excluyen los días anteriores al inicio de la recopilación de datos.",
    panelCalendar: "Calendario",
    panelChart: "Gráfico",
    noUsage: "Sin uso",
  },
  ring: {
    screenTime: "Tiempo en pantalla",
    activations: "Activaciones",
    percentOfTotal: "{percent} % del total",
    notTracked: "No registrado",
    screenActivationsByApp: "Activaciones de pantalla por app",
    screenTimeByApp: "Tiempo en pantalla por app",
    showScreenTime: "Mostrar tiempo en pantalla",
    showScreenActivations: "Mostrar activaciones de pantalla",
    chartDescriptionDay:
      "Tiempo en pantalla y activaciones por hora para el día seleccionado",
    chartDescriptionWeek:
      "Tiempo en pantalla y activaciones diarias para la semana seleccionada",
    chartDescriptionMonth:
      "Tiempo en pantalla y activaciones diarias para el mes seleccionado",
  },
  smartBlock: {
    goalDoom: "Reducir el doom-scroll",
    goalCompulsivity: "Reducir la compulsividad",
    actionLabel: "Bloquear por completo {range}",
    reasonDoomShare:
      "El {sharePct} % de tu uso de {name} ocurre entre {range}. Bloquear esa ventana apunta al periodo de mayor riesgo.",
    reasonDoomCluster:
      "El uso de {name} tiende a concentrarse en esta parte del día. Bloquear {range} apunta al periodo de mayor riesgo.",
    reasonCompulsivityOpens: "Abres {name} con más frecuencia entre {range}.",
    reasonCompulsivityTime: "La mayor parte de tu tiempo en {name} cae entre {range}.",
    reasonCompulsivityShareSuffix:
      "Un bloqueo completo en esa ventana rompe el ciclo del hábito.",
    reasonCompulsivityRepeat:
      "{name} recibe desbloqueos repetidos en esta parte del día. Un bloqueo completo entre {range} rompe el ciclo del hábito.",
    reactivateHint: "La regla existe pero está desactivada — toca para reactivarla",
  },
  permissionStatus: {
    granted: "Concedido",
    denied: "Denegado",
    unavailable: "No disponible",
    notDetermined: "Sin determinar",
  },
  onboarding: {
    progressLabel: "Progreso del onboarding",
    continue: "Continuar",
    working: "Procesando…",
    goToToday: "Ir a Hoy",
    narrative4Cta: "¿Para qué quieres ese tiempo?",
    narrative1ImageAlt: "Zero con la pantalla en la mano sin darse cuenta",
    narrative2ImageAlt: "Zero tirado de hilos hacia una pantalla brillante",
    narrative3ImageAlt: "Zero a la mesa sin móvil",
    narrative4ImageAlt: "Zero dando el primer paso en un camino sin móvil",
    narrative1: [
      "¿Alguna vez has notado cómo te encuentras con una pantalla en la mano sin siquiera darte cuenta? Bastan **15 segundos** de espera y ya buscas la pantalla.",
      "Hemos aprendido a **no dejar vacío** y a no contemplar ni siquiera un instante.",
      "Ping, scroll, pestaña: es fácil sentirse confuso y **dividido**.",
    ],
    narrative2: [
      "No es falta de **fuerza y voluntad**. Las apps están diseñadas e ingenierizadas para **mantenerte ahí**: cada scroll hace más difícil **desconectar**.",
      "Screen0 te ayuda a **crear distancia**, no a intentar ser **perfecto**.",
    ],
    narrative3: [
      "Menos pantalla no significa menos vida, significa más **espacio** para el trabajo, las personas, el sueño.",
      "Vuelve a experimentar una comida sin móvil, una noche sin scrolling: parecen límites pequeños, pero marcan una **gran diferencia**.",
    ],
    narrative4: [
      "**Ya has dado el primer paso.**",
      "Un paseo sin móvil. Una mañana sin feed. El cambio **empieza aquí**.",
    ],
    benefitsHeadline: "Así puede ayudarte **Screen0** en la próxima semana",
    benefits: [
      {
        title: "Enfócate en minutos",
        subtitle: "Configuración fácil y personalizable",
      },
      {
        title: "Recupera más de 2 horas al día",
        subtitle: "Menos scroll. Más tiempo para lo que importa.",
      },
      {
        title: "Haz más",
        subtitle: "Hasta un 50% más productivo en el trabajo con Screen0",
      },
      {
        title: "Duerme mejor",
        subtitle:
          "Deja de hacer scroll por la noche con un horario de descanso que de verdad funciona",
      },
    ],
    trialHeadline: "Prueba Premium **gratis.** Sin sorpresas.",
    trialRows: [
      {
        dayLabel: "TODAY",
        title: "Sin cargo hoy",
        subtitle:
          "Solo acceso a funciones Premium como Reglas y Smart Blocks",
      },
      {
        dayLabel: "DAY 5",
        title: "Recordatorio antes de que termine la prueba",
        subtitle: "Te avisaremos 2 días antes de que termine tu prueba gratuita",
      },
      {
        dayLabel: "DAY 7",
        title: "Cancela cuando quieras",
        subtitle: "Las suscripciones se pueden cancelar en cualquier momento",
      },
    ],
    primaryGoalQuestion: "¿Qué es lo más importante para lo que quieres tu tiempo?",
    timeLostQuestion: "¿Dónde pierdes más tiempo?",
    timeLostSubtitle: "Elegiste {goal} — ¿dónde se va el tiempo?",
    difficultyQuestion: "¿Qué tan difícil es resistir?",
    goals: {
      work: "Trabajo",
      study: "Estudio",
      sleep: "Sueño",
      family: "Familia",
      hobby: "Aficiones",
      exercise: "Ejercicio",
      balance: "Equilibrio",
      wellness: "Bienestar",
      other: "Otro",
    },
    timeLostOptions: {
      social: "Redes sociales",
      news: "Noticias",
      gaming: "Juegos",
      streaming: "Streaming",
      work: "Trabajo",
      shopping: "Compras",
      messages: "Mensajes",
      browsing: "Navegación",
      other: "Otro",
    },
    difficultyEmojis: ["😌", "🙂", "😐", "😣", "😫"],
    difficultyLevels: [
      "Muy fácil",
      "Fácil",
      "A veces difícil",
      "Difícil",
      "Muy difícil",
    ],
    insight8ImageAlt: "Escena nocturna con el móvil apartado",
    insight8Headline: "**Esto importa.**",
    insight8Body:
      "Proteger tu tiempo es uno de los límites que de verdad funcionan. Pequeños límites suman un cambio real.",
    insight8SleepHeadline: "**Esto importa.**",
    insight8SleepBody:
      "Después de las 19 el móvil puede esperar. **Desconectar por la noche** es uno de los límites que funcionan.",
    insight9ImageAlt: "Ilustración sobre atención y pantallas",
    insight9SocialHeadline: "Te enfrentas a una **máquina**.",
    insight9SocialBody: "El feed no tiene fin — está **diseñado** así.",
    insight9OtherHeadline: "Cada notificación **rompe** tu concentración.",
    insight9OtherBody: "Recuperarse puede llevar **20 minutos**.",
    notificationsHeadline:
      "Te enviaremos un recordatorio **2 días** antes de que termine tu prueba",
    notificationsBody:
      "Permite las notificaciones para enviarte un recordatorio antes del cargo",
    notificationsAllow: "PERMITIR NOTIFICACIONES",
    notificationsMaybeLater: "QUIZÁS DESPUÉS",
    notificationsDeniedWarning:
      "Las notificaciones están desactivadas. Actívalas en Ajustes para que podamos recordártelo antes de que termine tu prueba.",
    setupImageAlt: "Ilustración de permisos",
    setupTitle: "Un permiso rápido",
    setupBody:
      "Screen0 necesita acceso del sistema para mostrar tu informe personal. Sin cuenta requerida.",
    setupNativeHint: "Puedes cambiarlo cuando quieras en Ajustes.",
    setupWebHint:
      "En la web, los informes requieren la app móvil. Puedes continuar y configurarlo después en el teléfono.",
    vpnImageAlt: "Ilustración del filtro de sitios en el dispositivo",
    vpnTitle: "Instala el filtro de sitios",
    vpnBody:
      "Para bloquear sitios en Safari y otros navegadores móviles, Screen0 necesita añadir un perfil de filtro local.",
    vpnBodyAndroid:
      "Para bloquear sitios en Chrome y otros navegadores móviles, Screen0 necesita añadir un perfil de filtro local.",
    vpnPrivacyTitle: "Compromiso con la privacidad",
    vpnPrivacyBody:
      "Añade un filtro en el dispositivo que bloquea solo los sitios que tú elijas. Todo el filtrado ocurre en tu teléfono — tus datos nunca salen del dispositivo.",
    vpnWebHint:
      "En la web, el bloqueo de sitios requiere la app móvil. Puedes continuar y configurarlo después en el teléfono.",
    vpnInstall: "INSTALAR PERFIL",
    vpnNotNow: "AHORA NO",
    vpnErrorTitle: "No se pudo instalar el filtro",
    vpnErrorHint: "No se añadió el perfil VPN. Puedes omitirlo por ahora y volver a intentarlo más tarde.",
    trackingImageAlt: "Ilustración de analíticas anónimas",
    trackingTitle: "Apoya una mejor Screen0",
    trackingBody:
      "Permitir el seguimiento anónimo nos ayuda a entender qué funciona y a mejorar la app para todos.",
    trackingPrivacyTitle: "Compromiso con la privacidad",
    trackingPrivacyBody: "Sin anuncios, sin datos personales, sin vender tus datos. Nunca.",
    trackingAllow: "CONTINUAR",
    trackingNotNow: "AHORA NO",
    welcomeImageAlt: "Ilustración de bienvenida",
    welcomeTitle: "Estás listo.",
    welcomeRecap:
      "Quieres más tiempo para **{goal}**. Screen0 te ayudará a protegerlo — empezando hoy.",
    welcomeRecapFallback:
      "Screen0 te ayudará a proteger tu tiempo — empezando hoy.",
    paywall: {
      headline: "Recupera más de 2 horas al día con Screen0 Premium",
      timeline: [
        {
          title: "Comienza tu camino hacia el enfoque",
          description:
            "Vas por buen camino para convertir la intención en un hábito diario de concentración.",
        },
        {
          title: "Hoy: recupera tu enfoque",
          description:
            "Desbloquea herramientas potentes como **Reglas** y **Smart Blocks**. Configura tu primer límite y protege tu tiempo hoy.",
        },
        {
          title: "Día 5: nota la diferencia",
          description:
            "Para entonces notarás más calma, claridad y control sobre tu tiempo. Te avisaremos antes de que termine la prueba — sin sorpresas.",
        },
        {
          title: "Día 7: sigue adelante",
          description:
            "Continúa tu camino de enfoque con Premium. Cancela en cualquier momento si no es para ti.",
        },
      ],
      timelineTrialDescriptionWithTrial:
        "Inicia tu prueba gratuita de {trialDays} días y desbloquea herramientas potentes como **Reglas** y **Smart Blocks**. Configura tu primer límite y protege tu tiempo hoy.",
      timelineTrialDescriptionNoTrial:
        "Desbloquea herramientas potentes como **Reglas** y **Smart Blocks**. Configura tu primer límite y protege tu tiempo hoy.",
      yearlyBadgeWithTrial: "{trialDays} días de prueba gratis, luego {price} /año",
      yearlyBadgeNoTrial: "{price} /año",
      yearlyTitle: "Anual",
      yearlySubtext: "(Solo {monthlyPrice} /mes — menos que un café)",
      lifetimeTitle: "De por vida",
      lifetimeSubtext: "Compra única. Tuyo para siempre.",
      ctaYearly: "INICIAR PRUEBA GRATUITA",
      ctaLifetime: "OBTENER ACCESO DE POR VIDA",
      footerRenewal: "Se renueva automáticamente hasta cancelar. Cancela cuando quieras.",
      footerLifetime: "Compra única. Sin suscripción.",
      termsLink: "Términos",
      privacyLink: "Privacidad",
      purchase: {
        processing: "Procesando…",
        genericError: "Algo salió mal. Inténtalo de nuevo.",
        notEntitled: "Compra completada, pero Premium aún no está activo. Inténtalo de nuevo.",
        webUnavailable: "Las compras solo están disponibles en la app de Screen0.",
        configError: "Las compras no están disponibles ahora mismo. Inténtalo más tarde.",
        offeringsError: "No se pudieron cargar los precios. Comprueba tu conexión e inténtalo de nuevo.",
        retry: "Reintentar",
        restorePurchases: "Restaurar compras",
        restoreProcessing: "Restaurando…",
        restoreSuccess: "Compras restauradas. Premium está activo.",
        restoreNothingFound: "No hay compras que restaurar.",
        restoreNothingFoundApple: "No se encontraron compras para este ID de Apple.",
        restoreNothingFoundGoogle: "No se encontraron compras para esta cuenta de Google Play.",
        restoreError: "No se pudieron restaurar las compras. Inténtalo de nuevo.",
      },
    },
  },
  categories: {
    books: "Libros",
    business: "Negocios",
    catalogs: "Catálogos",
    developerTools: "Herramientas para desarrolladores",
    education: "Educación",
    entertainment: "Entretenimiento",
    finance: "Finanzas",
    foodAndDrink: "Comida y bebida",
    games: "Juegos",
    graphicsAndDesign: "Creatividad",
    healthAndFitness: "Salud y estado físico",
    kids: "Niños",
    lifestyle: "Estilo de vida",
    medical: "Medicina",
    miscellaneous: "Varios",
    music: "Música",
    navigation: "Navegación",
    news: "Información y lectura",
    newsstand: "Quiosco",
    photoAndVideo: "Foto y vídeo",
    productivity: "Productividad y finanzas",
    reference: "Referencia",
    shopping: "Compras y comida",
    socialNetworking: "Social",
    sports: "Deportes",
    stickers: "Pegatinas",
    travel: "Viajes",
    system: "Sistema",
    utilities: "Utilidades",
    weather: "Tiempo",
    uncategorized: "Otros",
    other: "Otros",
    website: "Sitio web",
  },
  websiteCategories: {
    modalTitle: "Categorías de sitios",
    expandInfoAria: "Mostrar detalles de {name}",
    collapseInfoAria: "Ocultar detalles de {name}",
    toggleCategoryAria: "Activar o desactivar {name}",
    domainsHeading: "Dominios incluidos",
    removeCategoryAria: "Quitar {name}",
    browseCategoriesButton: "Categorías",
    browseCategoriesAria: "Abrir categorías de sitios",
    addWebsiteAria: "Añadir sitio web",
    social: {
      name: "Social",
      description: "Redes sociales, foros y plataformas de comunidad.",
    },
    meta: {
      name: "Meta",
      description: "Facebook, Instagram, WhatsApp y Messenger.",
    },
    messaging: {
      name: "Mensajería",
      description: "Apps de chat y servicios de mensajería directa.",
    },
    news: {
      name: "Noticias",
      description: "Sitios de noticias, editoriales y medios informativos.",
    },
    dating: {
      name: "Citas",
      description: "Apps y sitios de citas.",
    },
  },
});

export default ES_TRANSLATIONS;
